
import { trackEvent } from '@/utils/analytics';

/**
 * Custom hook for tracking user interactions
 * This hook returns an event handler that can be attached to elements
 * 
 * @returns A function that logs events to Google Analytics
 */
export const useAnalyticsTracker = () => {
  /**
   * Track a user interaction event
   * 
   * @param category - Event category (e.g., 'Button', 'Link', 'Navigation')
   * @param action - Event action (e.g., 'Click', 'Submit')
   * @param label - Optional event label for additional context
   * @param value - Optional numeric value associated with the event
   * @returns A function that can be used as an event handler
   */
  const trackUserInteraction = (
    category: string,
    action: string,
    label?: string,
    value?: number
  ) => {
    return () => {
      trackEvent(category, action, label, value);
    };
  };

  return {
    trackUserInteraction
  };
};
